import API_URL from "../constant/api.config";
import _ from "lodash";
import axiosInstance from '../axiosHttp';
import { setAuthHeaders } from "../utils/common";
import Emitter from "../utils/Emitter";

export const viewProfileAction = (member_id) => async (dispatch) => {

  const headers = setAuthHeaders();

  return await axiosInstance.get(API_URL + "/view-profile/" + member_id, {
    headers
  })
    .then((response) => {
      // console.log('response======', response.data.data);
      dispatch({
        type: "VIEW_PROFILE_ACTION",
        payload: response.data
      });
      return response.data;
    })
    .catch((error) => {
      dispatch({
        type: "VIEW_PROFILE_ACTION",
        payload: error
      });
    });
}

export const updateMemberCredit = (viewer_id, viewed_id) => async (dispatch) => {
  const headers = setAuthHeaders();

  const payload = {
    viewer_id: viewer_id,
    viewed_id: viewed_id
  }

  return await axiosInstance.post(API_URL + "/updateCredits", payload, { headers }).then((response) => {
    // console.log("Response of updateMemberCredit ", response);
    if (response.data.status) {
      if (response.data.message === "CREDIT_UPDATED") {
        const savedUser = localStorage.getItem("user");
        let userInfo = savedUser ? JSON.parse(savedUser) : null;
        if (userInfo) {
          userInfo.view_credits = response.data.data;
          localStorage.setItem("user", JSON.stringify(userInfo));
          Emitter.emit("CREDIT_UPDATED", userInfo.member_id);
        }


      }
    }
  }).catch((err) => {
    console.log("Error == ", err);
  });
}